const check = [
  {
    id: 'check',
    name: 'Check',
    description: 'Checked or not checked.',
    choices: [
      {
        id: 'y',
        name: 'Selected',
        description: 'This item is selected.',
        color: 'blue',
        icon: 'check',
      },
    ],
  }
];
const yesNo = [
  {
    id: 'YesNo',
    name: 'Include',
    description: 'Include this item? Yes or no (or not checked).',
    choices: [
      {
        id: 'y',
        name: 'Yes',
        description: 'Include this item.',
        color: 'green',
        icon: 'check',
      },
      {
        id: 'n',
        name: 'No',
        description: 'Do not include this item.',
        color: 'red',
        icon: 'delete',
      },
    ],
  }
];
const optionalMandatory = [
  {
    id: 'OM',
    name: 'Optional or Mandatory',
    description: 'Include this item? Yes or no (or not checked).',
    choices: [
      {
        id: 'o',
        name: 'Optional',
        description: 'May include this item.',
        color: 'yellow',
        icon: 'question',
      },
      {
        id: 'm',
        name: 'Mandatory',
        description: 'Must include this item.',
        color: 'green',
        icon: 'exclamation',
      },
    ],
  }
];

const likert3 = [
  {
    id: 'l3',
    name: 'Likert 3',
    description: '3 Level Likert Scale: Agree...disagree (or not checked).',
    choices: [
      {
        id: 'd',
        name: 'Disagree',
        description: 'Disagree.',
        color: 'red',
        icon: 'frown',
      },
      {
        id: 'n',
        name: 'Neutral',
        description: 'Neutral.',
        color: 'yellow',
        icon: 'meh',
      },
      {
        id: 'a',
        name: 'Agree',
        description: 'Agree.',
        color: 'green',
        icon: 'smile',
      },
    ],
  }
];

const likert5 = [
  {
    id: 'l5',
    name: 'Likert 5',
    description: '5 Level Likert Scale: Strongly agree...strongly disagree (or not checked).',
    choices: [
      {
        id: 'sd',
        name: 'Strongly disagree',
        description: 'Strongly disagree.',
        color: 'red',
        icon: 'frown',
      },
      {
        id: 'd',
        name: 'Disagree',
        description: 'Disagree.',
        color: 'orange',
        icon: 'circle outline',
      },
      {
        id: 'n',
        name: 'Neutral',
        description: 'Neutral.',
        color: 'yellow',
        icon: 'meh',
      },
      {
        id: 'a',
        name: 'Agree',
        description: 'Agree.',
        color: 'olive',
        icon: 'circle outline',
      },
      {
        id: 'sa',
        name: 'Strongly agree',
        description: 'Strongly agree.',
        color: 'green',
        icon: 'smile',
      },
    ],
  }
];

const prePostType = [
  {
    id: 'pre',
    name: 'Prerequisites',
    description: 'The prerequisites (preconditions) of this course. At the beginning of the course.',
    choices: [
      {
        id: 'r',
        name: 'Partially required',
        description: 'This course requires students to already have at least a partial understanding of the item.',
        color: 'teal',
        icon: 'thermometer half',
      },
      {
        id: 'R',
        name: 'Fully required',
        description: 'This course requires students to already have a thorough understanding of the item.',
        color: 'blue',
        icon: 'thermometer full',
      },
    ],
  },
  {
    id: 'post',
    name: 'Goals',
    description: 'The goals (postconditions) of this course. At the end of the course.',
    choices: [
      {
        id: 'e',
        name: 'Partially ensured',
        description: 'This course ensures that students will have at least a partial understanding of the item.',
        color: 'olive',
        icon: 'star half',
      },
      {
        id: 'E',
        name: 'Fully ensured',
        description: 'This course ensures that students will have a thorough understanding of the item.',
        color: 'green',
        icon: 'star',
      },
    ],
  },
];

const typePresets = [
  check,
  yesNo,
  optionalMandatory,
  likert3,
  likert5,
  prePostType,
];

export default typePresets